module.exports = __webpack_public_path__ + "static/media/carroussel_17.438b2fd5.jpg";